import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function NextSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M15.8971333 25.7561333v-6.1006666H8.60246667V12.6828h7.29466663V6.58146667l9.588 9.58733333-9.588 9.5873333zm.302-25.2033333C7.57913333.5528.58313333 7.5488.58313333 16.1688c0 8.6206667 6.996 15.6166667 15.61599997 15.6166667 8.6206667 0 15.6166667-6.996 15.6166667-15.6166667 0-8.62-6.996-15.616-15.6166667-15.616z"
        />
      </g>
    </svg>
  )
}

NextSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
